module.exports = __webpack_public_path__ + "media/jobs_page/shopper-icon-8cd8dd28.svg";